import React from 'react';

import CoreComments from '@spp/ui-core-comments';
import LazyLoad from 'react-lazy-load';

// eslint-disable-next-line react/prop-types
const CoreCommentsComponent = ({ articleId }) => {
    const theme = {
        // eslint-disable-line no-underscore-dangle
        // avatars toggle (default: false)
        avatarsEnabled: false,
        // rules url for publication (default: null)
        rulesUrl: 'https://www.vg.no/informasjon/moderering/',
        // primary CTA (publish comment button) options
        ctaBackgroundColor: '#1199CC',
        ctaBorderRadius: '0px',
        ctaBorderColor: '#1199CC',
        ctaPadding: '5px',
        ctaTextColor: '#fff',
        // secondary CTA (load more buttons etc.) options
        secondaryCtaBackgroundColor: 'transparent',
        secondaryCtaBorderRadius: '100px',
        secondaryCtaBorderColor: '#1199CC',
        secondaryCtaPadding: '4px 12px',
        secondaryCtaTextColor: '#1199CC',
        // links (reply, vote)
        linkColor: '#1199CC',
        linkBorderBottom: 'none',
        linkFontWeight: '300',
    };

    const extraProps = {};

    if (process.env.NODE_ENV === 'production') {
        extraProps.embedScript = '//cmmnts.i.bt.no/assets/embedd.js';
    }

    return (
        <LazyLoad offset={1500} debounce={false} throttle={100}>
            <CoreComments
                contentId={articleId}
                publication="vg"
                contentType="article"
                lang={'nb-no'}
                theme={theme}
                {...extraProps}
            />
        </LazyLoad>
    );
};

export default CoreCommentsComponent;



/** WEBPACK FOOTER **
 ** ./src/local-components/article/CoreComments.js
 **/